<rt-dialog-header [heading]="title" />

<div class="confirm-body" space-lr padding-tb-small>
  <p>
    {{ message }}
  </p>
</div>

<rt-divider />

<div class="confirm-actions" space-lr padding-tb-small>
  <rt-group variant="horizontal" layout-justify-flex-end>
    <rt-button (click)="cancel()" variant="plain" margin-right-small>
      {{ cancelLabel }}
    </rt-button>
    <rt-button variant="primary" [loading]="loading" (click)="confirm()">
      {{ agreeLabel }}
    </rt-button>
  </rt-group>
</div>
